import {Event} from 'src/app/model/event/event.model';

export class PlaceEventDTO {
    idPlace: number;
    events: Event[];
}
